import { createI18n } from 'vue-i18n';
import ar from './locales/messages/ar.json';
import en from './locales/messages/en.json';
import es from './locales/messages/es.json';
import fr from './locales/messages/fr.json';
import id from './locales/messages/id.json';
import ja from './locales/messages/ja.json';
import pt from './locales/messages/pt.json';
import zh from './locales/messages/zh.json';

const primary = import.meta.env.VITE_I18N_LOCALE;
const fallback = import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en';

export const snakeI18n = createI18n({
    locale: primary,
    fallbackLocale: fallback,
    messages: {ar, en, es, fr, id, ja, pt, zh},
    warnHtmlMessage: false,
    warnHtmlInMessage: 'off',
});
